import React from "react";
import { Icon } from "@iconify/react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PageHeader from "../../components/common/PageHeader";
import AfterPayLayer from "../../components/sales/AfterPayLayer";

const AfterPayPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* AfterPay Layer com Header Integrado */}
        <AfterPayLayer />

      </MasterLayout>

    </>
  );
};

export default AfterPayPage;
